import React, { useReducer, useState } from "react";

export const UserContext = React.createContext();

const defaultState = {
  user: JSON.parse(localStorage.getItem("user")) || {},
};

const userReducer = (state, action) => {
  const { type, payload } = action;

  if (type === "LOGIN") {
    return {
      user: payload,
    };
  }
  if (type === "LOGOUT") {
    localStorage.removeItem("user");
    return {
      user: {},
    };
  }

  return defaultState;
};

export const UserProvider = (props) => {
  const [userState, dispatch] = useReducer(userReducer, defaultState);
  const [performanceData, setPerformanceData] = useState(null);
  const [configurationData, setConfigurationData] = useState(null);
  const [templateData, setTemplateData] = useState(null);

  const login = (item) => {
    dispatch({ type: "LOGIN", payload: item });
  };

  const logout = (item) => {
    dispatch({ type: "LOGOUT" });
  };

  const perform = (item) => {
    setPerformanceData(item);
  };

  const config = (item) => {
    setConfigurationData(item);
  };

  const template = (item) => {
    setTemplateData(item);
  }

  const contextValue = {
    user: userState.user,
    login: login,
    logout: logout,
    perform: perform,
    performanceData: performanceData,
    config: config,
    configurationData: configurationData,
    template: template,
    templateData: templateData
  };

  return (
    <UserContext.Provider value={contextValue}>
      {props.children}
    </UserContext.Provider>
  );
};
